<style scoped lang="stylus" rel="stylesheet/stylus">
.container
  background #f2f2f2
  min-height 100%
  .father
    position relative
    left 20px
    top 80px
    width 300px
    height 400px
    border 10px solid blue
    padding 10px
  .child
    position absolute
    left 0
    top 0
    width 50px
    height 50px
    border 5px solid pink
    background gold
</style>

<template>
	<div class="container">
		<nav-bar />
		<van-button @click="$router.push('/pdf')">跳转拖pdf</van-button>
		<div id="father" class="father">
			<div id="child" class="child"></div>
		</div>
	</div>
</template>

<script>
import navBar from '../../components/navigation/nav-bar'
export default {
	name: 'drag',
	components: {
		navBar
	},
	props: {},
	filters: {},
	computed: {},
	data() {
		return {}
	},
	methods: {},
	created() {
		console.log('created')
	},
	mounted() {
		let child = document.querySelector('#child')
		let father = document.querySelector('#father')
		var fatherWidth = father.clientWidth
		var fatherHeight = father.clientHeight
		var childWidth = child.offsetWidth
		var childHeight = child.offsetHeight
		//    pc端版本的js
		//    console.log('child',child)
		//    child.onmousedown = (e) => {
		//      var oldLeft = child.offsetLeft
		//      var oldTop = child.offsetTop
		//      var x = e.clientX
		//      var y = e.clientY
		//      console.log(oldLeft, oldTop, x, y, e);
		//      document.onmousemove = (e) => {
		//        var left = oldLeft + e.clientX - x
		//        var top = oldTop + e.clientY - y
		//        if (left < 0) left = 0
		//        if (left > fatherWidth - childWidth) left = fatherWidth - childWidth
		//        if (top < 0) top = 0
		//        if (top > fatherHeight - childHeight) top = fatherHeight - childHeight
		//        child.style.left = left + 'px'
		//        child.style.top = top + 'px'
		//      }
		//    }
		//    document.onmouseup = (e) => {
		//      document.onmousemove = null
		//    }
		//    pc端版本的js

		//    移动端版本的js
		console.log('child', child)
		child.ontouchstart = e => {
			var oldLeft = child.offsetLeft
			var oldTop = child.offsetTop
			var x = e.touches[0].clientX
			var y = e.touches[0].clientY
			console.log(oldLeft, oldTop, x, y, e)
			child.ontouchmove = e => {
				var left = oldLeft + e.touches[0].clientX - x
				var top = oldTop + e.touches[0].clientY - y
				if (left < 0) left = 0
				if (left > fatherWidth - childWidth) left = fatherWidth - childWidth
				if (top < 0) top = 0
				if (top > fatherHeight - childHeight) top = fatherHeight - childHeight
				child.style.left = left + 'px'
				child.style.top = top + 'px'
			}
		}
		child.ontouchend = e => {
			child.ontouchmove = null
		}
		//    移动端版本的js
	}
}
</script>
